import * as actions from 'constants/actions'
import * as apiResponse from 'constants/errorCodes'

import {push} from 'connected-react-router'

const errorDispatcher = (code, type, dispatch) => {
    // automatically intercept when session is expired
    if (code === apiResponse.SESSION_EXPIRED_RESPONSE_CODE) {
        dispatch(push('/login'))
    }
    else if (code === apiResponse.USER_NOT_ADMIN_CODE) {
        dispatch(push('/account/home'))
        dispatch({
            type,
            error: {
                message: apiResponse.mappedCode[code]
            },
        })
    }
    else if (code === apiResponse.INVALID_CREDENTIALS_RESPONSE_CODE) {
        dispatch({
            type,
            error: {
                message: 'Yikes, your details seem to be incorrect! Have you forgotten them?'
            },
        })
    }
    else if (apiResponse.mappedCode[code]) {
        dispatch({
            type,
            error: {
                message: apiResponse.mappedCode[code]
            },
        })

    }
    else {
        console.error("unknown error", code, type)
        dispatch({
            type,
            error: {
                message: apiResponse.UNKNOWN_RESPONSE_MESSAGE
            },
        })
    }
}

export default errorDispatcher



// WEBPACK FOOTER //
// ./src/utils/errorDispatcher.js